import platformType from "@/utils/platformType";

export const usePlatformType = () => {
  const isIos = () => platformType.isIos()
  const isAndroid = () => platformType.isAndroid()
  const isNative = () => isIos() || isAndroid()

  return { isIos, isAndroid, isNative }
}
